import { HostListener, Injectable, OnInit } from '@angular/core';
import { map, shareReplay, catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { ApiService } from './api.service';
import { DocumentService } from './document.service';
import { AuthService } from '../auth/auth.service';
import { Routes } from '../constants/routes';
import { StorageService } from './storage.service';
import { TimeoutSessionService } from './timeout-session.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import {EnvService} from './env.service';
import { CommonService } from './common.service';
import {MultiDownloadService} from './multi-download.service';

const route = {
  logout: () => `/auth/logout`,
  check: `/auth/login/fail-info`,
  refreshToken: `/auth/refresh-token`,
  refreshAnonymousToken: `/anonymous/refresh-cookie`,
  changeMode: `/auth/change-mode`,
  loginWithGoogle: '/auth/login-with-google',
  loginWithZalo: '/auth/login-with-zalo'

};

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  private currentUserSubject: BehaviorSubject<any>;
  public timeWaitSign: BehaviorSubject<any>;
  public selectedCert: BehaviorSubject<any>;
  public currentUser: Observable<any>;
  public messageErrors: boolean;
  private userType: any;
  private ssoLink: string;
  private ssoHost: string;

  /**
   * <pre>
   * <b>Method name: constructor</b>
   * <b>Explanation: </b> Method constructor
   * </pre>
   * @author GCS 2019/08/25 by linhdh
   *
   */
  constructor(
    private httpClient: HttpClient,
    private apiService: ApiService,
    private authService: AuthService,
    private storage: StorageService,
    private documentService: DocumentService,
    private router: Router,
    private env: EnvService,
    private downloadService: MultiDownloadService,
    private commonService: CommonService
  ) {
    // this.currentUserSubject = new BehaviorSubject<any>(JSON.stringify(localStorage.getItem("currentUser")));
    this.currentUserSubject = new BehaviorSubject<any>('');
    this.timeWaitSign = new BehaviorSubject<any>('');
    this.selectedCert = new BehaviorSubject<any>('');
    this.currentUser = this.currentUserSubject.asObservable();
    this.ssoLink = `${env.sme_portal_url}/header-iframe?origin=${env.sme_portal_url}&client_id=${env.sme_client_id}&redirect_uri=${env.vcontract_url}/callback`;
    this.ssoHost = env.sme_portal_url;
  }

  public get currentUserValue(): any {
    return this.currentUserSubject.value;
  }
  public get timeWaitSignValue(): any {
    return this.timeWaitSign.value;
  }

  /**
   * <pre>
   * <b>Method name: login</b>
   * <b>Explanation: </b> Method login
   * </pre>
   * @author GCS 2019/08/25 by linhdh
   *
   */

  loginWithCode(payload:any) {
    console.log('login with code');
    localStorage.removeItem('informationForSurvey');
    localStorage.removeItem('dataForSurvey');
    // window.dispatchEvent(new Event('header-login'))
    return this.apiService.post('/auth/login-sso', payload).pipe(
      map(response => {
        if (response && response.data && response.data.token) {
          this.authService.storeAccessToken(response.data.token, false);
          localStorage.setItem('tenantId', response.data.tenantId);
          localStorage.setItem('userId', response.data.userId);
          localStorage.setItem('userName', response.data.username);
          localStorage.setItem('fullName', response.data.fullName);
          localStorage.setItem('enterpriseId', response.data.enterpriseId);
          localStorage.setItem('parentId', response.data.parentId);
          localStorage.setItem('permissions', JSON.stringify(response.data.permissions));
          localStorage.setItem('featureStatus', JSON.stringify(response.data.featureStatus));
          localStorage.setItem('defaultPermission', JSON.stringify(response.data.defaultPermission));
          localStorage.setItem('userType', response.data.userType);
          localStorage.setItem('entType', response.data.entType);
          localStorage.setItem('isParent', response.data.isParent);
          localStorage.setItem('cecaEnable', response.data.cecaEnable);
          localStorage.setItem('isLocked', response.data.isLocked);
          localStorage.setItem('cloudCaMultiSignThreshold', response.data.cloudCaMultiSignThreshold);
          localStorage.setItem('usbTokenMultiSignThreshold', response.data.usbTokenMultiSignThreshold);
          localStorage.setItem('isFromSSO', response.data.isFromSSO);
          localStorage.setItem('approverNumber', response.data.approverNumber);
          localStorage.setItem('dayToExpire', response.data.dayToExpire);
          localStorage.setItem('ssoLink', this.ssoLink);
          localStorage.setItem('userServices', JSON.stringify(response.data.userService.userServices));
          localStorage.setItem('lastChangePassword', response.data.lastChangePassword);
          localStorage.setItem('isAdminDefault', response.data.isAdminDefault);
          localStorage.setItem('isShareMysignEnable', response.data.isShareMysignEnable);
          localStorage.setItem('maxCustomerInFileImport', response.data.maxCustomerInFileImport);
          localStorage.setItem('isApplyContractMoha', response.data.isApplyContractMoha === true ? 'true' : 'false');

          localStorage.setItem('isEnterpriseApplyVerifyVneId', response.data.isEnterpriseApplyVerifyVneId);
          localStorage.setItem('typeVerifyVneId', response.data.typeVerifyVneId);

          // console.log('login data',response.data);
          // this.timeoutSessionService.start();
          this.currentUserSubject.next(response.data.token);
        }
        let inforForSv = {};
        if(response.data.addressDTO && response.data.addressDTO.length > 0){
          inforForSv = {
            name: response.data.username,
            surveyURL:response.data.surveyUrl,
            CAMPAIGN_CONTACT_NUMBER: response.data ? response.data.phoneNumber:null,
            PROVINCE_CODE:response.data.addressDTO ? response.data.addressDTO.cityId:null,
            DISTRICT_CODE:response.data.addressDTO ? response.addressDTO.districtId :null,
            PRECINCT_CODE:response.data.addressDTO ? response.data.addressDTO.wardId:null,
            SME_ADDRESS:response.data.addressDTO ? response.data.addressDTO.address :null,
          };
        }
        else {
          inforForSv = {
            name: response.data.username,
            surveyURL:response.data.surveyUrl,
            CAMPAIGN_CONTACT_NUMBER:null,
            PROVINCE_CODE:null,
            DISTRICT_CODE:null,
            PRECINCT_CODE:null,
            SME_ADDRESS:null,
          };
        }
        localStorage.setItem('informationForSurvey',JSON.stringify(inforForSv))
           localStorage.setItem('dataForSurvey',JSON.stringify(response.data.data))
        return response.data;
      })
    );
  }


  loginSsoByVneid(url: string, body: any) {
    localStorage.removeItem('informationForSurvey');
    localStorage.removeItem('dataForSurvey');
    return this.apiService.post(url, body).pipe(
      map(response => {
        console.log("ress",response)
        if (response && response.data && response.data.token) {
          this.authService.storeAccessToken(response.data.token, false);
          localStorage.setItem('tenantId', response.data.tenantId);
          localStorage.setItem('userId', response.data.userId);
          localStorage.setItem('userName', response.data.username);
          localStorage.setItem('fullName', response.data.fullName);
          localStorage.setItem('enterpriseId', response.data.enterpriseId);
          localStorage.setItem('parentId', response.data.parentId);
          localStorage.setItem('permissions', JSON.stringify(response.data.permissions));
          localStorage.setItem('featureStatus', JSON.stringify(response.data.featureStatus));
          localStorage.setItem('defaultPermission', JSON.stringify(response.data.defaultPermission));
          localStorage.setItem('userType', response.data.userType);
          localStorage.setItem('isParent', response.data.isParent);
          localStorage.setItem('cecaEnable', response.data.cecaEnable);
          localStorage.setItem('isLocked', response.data.isLocked);
          localStorage.setItem('cloudCaMultiSignThreshold', response.data.cloudCaMultiSignThreshold);
          localStorage.setItem('usbTokenMultiSignThreshold', response.data.usbTokenMultiSignThreshold);
          localStorage.setItem('isShareMysignEnable', response.data.isShareMysignEnable);
          localStorage.setItem('maxCustomerInFileImport', response.data.maxCustomerInFileImport);
          localStorage.setItem('isApplyContractMoha', response.data.isApplyContractMoha === true ? 'true' : 'false');
          localStorage.setItem('isEnterpriseApplyVerifyVneId', response.data.isEnterpriseApplyVerifyVneId);
          localStorage.setItem('typeVerifyVneId', response.data.typeVerifyVneId);
          // console.log('login data',response.data);
          // this.timeoutSessionService.start();
          this.currentUserSubject.next(response.data.token);
        }
        let inforForSv = {};
        if(response.data && response.data.addressDTO && response.data.addressDTO.length > 0){
          inforForSv = {
            name: response.data.username,
            surveyURL:response.data.surveyUrl,
            CAMPAIGN_CONTACT_NUMBER: response.data ? response.data.phoneNumber:null,
            PROVINCE_CODE:response.data.addressDTO ? response.data.addressDTO.cityId:null,
            DISTRICT_CODE:response.data.addressDTO ? response.addressDTO.districtId :null,
            PRECINCT_CODE:response.data.addressDTO ? response.data.addressDTO.wardId:null,
            SME_ADDRESS:response.data.addressDTO ? response.data.addressDTO.address :null,
          };
        }
        else {
          inforForSv = {
            name: response.data ? response.data.username : '',
            surveyURL: response.data ? response.data.surveyUrl : '',
            CAMPAIGN_CONTACT_NUMBER:null,
            PROVINCE_CODE:null,
            DISTRICT_CODE:null,
            PRECINCT_CODE:null,
            SME_ADDRESS:null,
          };
        }

        localStorage.setItem('informationForSurvey',JSON.stringify(inforForSv))
        if (response.data) {
          localStorage.setItem('dataForSurvey',JSON.stringify(response.data.data))
        }
        return response;
      })
    );
  }
  login(url, username, password, isRemember, slideCaptcha, isNotHuman, cpCode?) {
    localStorage.removeItem('informationForSurvey');
    localStorage.removeItem('dataForSurvey');
    return this.apiService.post(url, { username, password, slideCaptcha, isNotHuman, cpCode, isWebSystem: true }).pipe(
      map(response => {
        console.log("ress",response)
        if (response && response.data && response.data.token) {
          this.authService.storeAccessToken(response.data.token, isRemember);
          localStorage.setItem('tenantId', response.data.tenantId);
          localStorage.setItem('userId', response.data.userId);
          localStorage.setItem('userName', response.data.username);
          localStorage.setItem('fullName', response.data.fullName);
          localStorage.setItem('enterpriseId', response.data.enterpriseId);
          localStorage.setItem('parentId', response.data.parentId);
          localStorage.setItem('permissions', JSON.stringify(response.data.permissions));
          localStorage.setItem('featureStatus', JSON.stringify(response.data.featureStatus));
          localStorage.setItem('defaultPermission', JSON.stringify(response.data.defaultPermission));
          localStorage.setItem('userType', response.data.userType);
          localStorage.setItem('isParent', response.data.isParent);
          localStorage.setItem('cecaEnable', response.data.cecaEnable);
          localStorage.setItem('isLocked', response.data.isLocked);
          localStorage.setItem('cloudCaMultiSignThreshold', response.data.cloudCaMultiSignThreshold);
          localStorage.setItem('usbTokenMultiSignThreshold', response.data.usbTokenMultiSignThreshold);
          localStorage.setItem('isShareMysignEnable', response.data.isShareMysignEnable);
          localStorage.setItem('maxCustomerInFileImport', response.data.maxCustomerInFileImport);
          localStorage.setItem('isApplyContractMoha', response.data.isApplyContractMoha === true ? 'true' : 'false');

          localStorage.setItem('isEnterpriseApplyVerifyVneId', response.data.isEnterpriseApplyVerifyVneId);
          localStorage.setItem('typeVerifyVneId', response.data.typeVerifyVneId);

          // console.log('login data',response.data);
          // this.timeoutSessionService.start();
          this.currentUserSubject.next(response.data.token);
        }
        let inforForSv = {};
        if(response.data && response.data.addressDTO && response.data.addressDTO.length > 0){
          inforForSv = {
            name: response.data.username,
            surveyURL:response.data.surveyUrl,
            CAMPAIGN_CONTACT_NUMBER: response.data ? response.data.phoneNumber:null,
            PROVINCE_CODE:response.data.addressDTO ? response.data.addressDTO.cityId:null,
            DISTRICT_CODE:response.data.addressDTO ? response.addressDTO.districtId :null,
            PRECINCT_CODE:response.data.addressDTO ? response.data.addressDTO.wardId:null,
            SME_ADDRESS:response.data.addressDTO ? response.data.addressDTO.address :null,
          };
        }
        else {
          inforForSv = {
            name: response.data ? response.data.username : '',
            surveyURL: response.data ? response.data.surveyUrl : '',
            CAMPAIGN_CONTACT_NUMBER:null,
            PROVINCE_CODE:null,
            DISTRICT_CODE:null,
            PRECINCT_CODE:null,
            SME_ADDRESS:null,
          };
        }

        localStorage.setItem('informationForSurvey',JSON.stringify(inforForSv))
        if (response.data) {
          localStorage.setItem('dataForSurvey',JSON.stringify(response.data.data))
        }
        return response;
      })
    );
  }

  loginFirebase(url, token, isRemember) {
    return this.apiService.post(url, token).pipe(
      map(response => {
        if (response && response.data && response.data.token) {
          this.authService.storeAccessToken(response.data.token, isRemember);
          localStorage.setItem('permissionDTOS', JSON.stringify(response.data.permissionDTOS));
          localStorage.setItem('isBuyContractDigital', response.data.isBuyContractDigital);
          if (response.data.isBuyContractDigital) {
            localStorage.setItem('isLockedContractDigital', response.data.isLockedContractDigital);
          }
          localStorage.setItem('tenantId', response.data.tenantId);
          localStorage.setItem('enableDocumentEnterprise', JSON.stringify(response.data.enableDocumentEnterprise));
          localStorage.setItem('userId', response.data.userId);
          localStorage.setItem('isViettelGroup', response.data.isViettelGroup);
          localStorage.setItem('showSettingDefaultCert', response.data.showSettingDefaultCert == undefined ? true : response.data.showSettingDefaultCert);
          localStorage.setItem('userName', response.data.username);
          localStorage.setItem('fullName', response.data.fullName);
          localStorage.setItem('enterpriseId', response.data.enterpriseId);
          localStorage.setItem('parentId', response.data.parentId);
          localStorage.setItem('permissions', JSON.stringify(response.data.permissions));
          localStorage.setItem('featureStatus', JSON.stringify(response.data.featureStatus));
          localStorage.setItem('defaultPermission', JSON.stringify(response.data.defaultPermission));
          localStorage.setItem('userType', response.data.userType);
          localStorage.setItem('isParent', response.data.isParent);
          localStorage.setItem('cecaEnable', response.data.cecaEnable);
          localStorage.setItem('isLocked', response.data.isLocked);
          localStorage.setItem('cloudCaMultiSignThreshold', response.data.cloudCaMultiSignThreshold);
          localStorage.setItem('usbTokenMultiSignThreshold', response.data.usbTokenMultiSignThreshold);
          // console.log('login data',response.data);
          // this.timeoutSessionService.start();
          this.currentUserSubject.next(response.data.token);
        }
        return response;
      })
    );
  }

  loginWithGoogle(body: any,isRemember: any) {
    return this.apiService.post(route.loginWithGoogle, body).pipe(map(response => {
      console.log("ress",response)
        if (response && response.data && response.data.token) {
          this.authService.storeAccessToken(response.data.token, isRemember);
          localStorage.setItem('tenantId', response.data.tenantId);
          localStorage.setItem('userId', response.data.userId);
          localStorage.setItem('userName', response.data.username);
          localStorage.setItem('fullName', response.data.fullName);
          localStorage.setItem('enterpriseId', response.data.enterpriseId);
          localStorage.setItem('parentId', response.data.parentId);
          localStorage.setItem('permissions', JSON.stringify(response.data.permissions));
          localStorage.setItem('featureStatus', JSON.stringify(response.data.featureStatus));
          localStorage.setItem('defaultPermission', JSON.stringify(response.data.defaultPermission));
          localStorage.setItem('userType', response.data.userType);
          localStorage.setItem('isParent', response.data.isParent);
          localStorage.setItem('cecaEnable', response.data.cecaEnable);
          localStorage.setItem('isLocked', response.data.isLocked);
          localStorage.setItem('cloudCaMultiSignThreshold', response.data.cloudCaMultiSignThreshold);
          localStorage.setItem('usbTokenMultiSignThreshold', response.data.usbTokenMultiSignThreshold);
          localStorage.setItem('isShareMysignEnable', response.data.isShareMysignEnable);

          // console.log('login data',response.data);
          // this.timeoutSessionService.start();
          this.currentUserSubject.next(response.data.token);
        }
        let inforForSv = {};
        if(response.data && response.data.addressDTO && response.data.addressDTO.length > 0){
          inforForSv = {
            name: response.data.username,
            surveyURL:response.data.surveyUrl,
            CAMPAIGN_CONTACT_NUMBER: response.data ? response.data.phoneNumber:null,
            PROVINCE_CODE:response.data.addressDTO ? response.data.addressDTO.cityId:null,
            DISTRICT_CODE:response.data.addressDTO ? response.addressDTO.districtId :null,
            PRECINCT_CODE:response.data.addressDTO ? response.data.addressDTO.wardId:null,
            SME_ADDRESS:response.data.addressDTO ? response.data.addressDTO.address :null,
          };
        }
        else {
          inforForSv = {
            name: response.data ? response.data.username : '',
            surveyURL: response.data ? response.data.surveyUrl : '',
            CAMPAIGN_CONTACT_NUMBER:null,
            PROVINCE_CODE:null,
            DISTRICT_CODE:null,
            PRECINCT_CODE:null,
            SME_ADDRESS:null,
          };
        }

        localStorage.setItem('informationForSurvey',JSON.stringify(inforForSv))
        if (response.data) {
          localStorage.setItem('dataForSurvey',JSON.stringify(response.data.data))
        }
      return response;
    }));
  }

  loginWithZalo(body: any,isRemember: any) {
    return this.apiService.post(route.loginWithZalo, body).pipe(map(response => {
      console.log("ress",response)
      if (response && response.data && response.data.token) {
        this.authService.storeAccessToken(response.data.token, isRemember);
        localStorage.setItem('tenantId', response.data.tenantId);
        localStorage.setItem('userId', response.data.userId);
        localStorage.setItem('userName', response.data.username);
        localStorage.setItem('fullName', response.data.fullName);
        localStorage.setItem('enterpriseId', response.data.enterpriseId);
        localStorage.setItem('parentId', response.data.parentId);
        localStorage.setItem('permissions', JSON.stringify(response.data.permissions));
        localStorage.setItem('featureStatus', JSON.stringify(response.data.featureStatus));
        localStorage.setItem('defaultPermission', JSON.stringify(response.data.defaultPermission));
        localStorage.setItem('userType', response.data.userType);
        localStorage.setItem('isParent', response.data.isParent);
        localStorage.setItem('cecaEnable', response.data.cecaEnable);
        localStorage.setItem('isLocked', response.data.isLocked);
        localStorage.setItem('cloudCaMultiSignThreshold', response.data.cloudCaMultiSignThreshold);
        localStorage.setItem('usbTokenMultiSignThreshold', response.data.usbTokenMultiSignThreshold);
        localStorage.setItem('isShareMysignEnable', response.data.isShareMysignEnable);

        // console.log('login data',response.data);
        // this.timeoutSessionService.start();
        this.currentUserSubject.next(response.data.token);
      }
      let inforForSv = {};
      if(response.data && response.data.addressDTO && response.data.addressDTO.length > 0){
        inforForSv = {
          name: response.data.username,
          surveyURL:response.data.surveyUrl,
          CAMPAIGN_CONTACT_NUMBER: response.data ? response.data.phoneNumber:null,
          PROVINCE_CODE:response.data.addressDTO ? response.data.addressDTO.cityId:null,
          DISTRICT_CODE:response.data.addressDTO ? response.addressDTO.districtId :null,
          PRECINCT_CODE:response.data.addressDTO ? response.data.addressDTO.wardId:null,
          SME_ADDRESS:response.data.addressDTO ? response.data.addressDTO.address :null,
        };
      }
      else {
        inforForSv = {
          name: response.data ? response.data.username : '',
          surveyURL: response.data ? response.data.surveyUrl : '',
          CAMPAIGN_CONTACT_NUMBER:null,
          PROVINCE_CODE:null,
          DISTRICT_CODE:null,
          PRECINCT_CODE:null,
          SME_ADDRESS:null,
        };
      }

      localStorage.setItem('informationForSurvey',JSON.stringify(inforForSv))
      if (response.data) {
        localStorage.setItem('dataForSurvey',JSON.stringify(response.data.data))
      }
      return response;
    }));
  }
  /**
   * <pre>
   * <b>Method name: isUserLoggedIn</b>
   * <b>Explanation: </b> Method check login
   * </pre>
   * @author GCS 2019/08/25 by linhdh
   *
   */
  isUserLoggedIn() {
    const user = localStorage.getItem('username');
    return !(user === null);
  }

  /**
   * <pre>
   * <b>Method name: checkLoginFail</b>
   * <b>Explanation: </b> Method check login
   * </pre>
   * @author GCS 2019/08/25 by hungvo
   *
   */
  checkLoginFail() {
    return this.apiService.get(route.check).pipe(map(rs => {
      return rs;
    }));
  }

  /**
   * <pre>
   * <b>Method name: logout</b>
   * <b>Explanation: </b> Method logout
   * </pre>
   * @author GCS 2019/08/25 by linhdh
   *
   */
  logout() {
    this.invalidatePermissionInfo();
    const token = this.authService.getToken();
    if (token) {
      this.apiService.post(
        route.logout()
      ).subscribe();
    }
    localStorage.removeItem('tenantId');
    localStorage.removeItem('fullName');
    // localStorage.removeItem('error_code_document');
    localStorage.removeItem('userId');
    localStorage.removeItem('enterpriseId');
    // localStorage.removeItem('__language');
    localStorage.removeItem('blockUI');
    localStorage.removeItem('defaultPermission');
    localStorage.removeItem('userType');
    localStorage.removeItem('isParent');
    localStorage.removeItem('permissions');
    localStorage.removeItem('cecaEnable');
    localStorage.removeItem('isLocked');
    localStorage.removeItem('cloudCaMultiSignThreshold');
    localStorage.removeItem('userServices');
    localStorage.removeItem('entType');
    localStorage.removeItem('featureStatus');
    localStorage.removeItem('isAdminDefault');
    localStorage.removeItem('dataOldPopup');
    localStorage.removeItem('procedureIdActive');
    // localStorage.clear();
    // sessionStorage.clear();
    this.authService.removeToken();
    this.currentUserSubject.next(null);
    this.documentService.clearResource();
    this.downloadService.setOpen(false);
    localStorage.setItem('other_tab_logout', 'tmp');
    localStorage.removeItem('other_tab_logout');
    localStorage.removeItem('dayToExpire');
    localStorage.removeItem('passwordExpired');
    localStorage.removeItem('numberDayShowWarningPassword');
    localStorage.removeItem('isFromSSO');
    localStorage.removeItem('informationForSurvey');
    this.commonService.entTypeChange.next(true);
  }

  anonymousLogout() {
    sessionStorage.removeItem('tenantId');
    sessionStorage.removeItem('hashKey');
    sessionStorage.removeItem('contractIdAndContractEnterpriseIdEncode');
    localStorage.removeItem('SignDataValidate');
    localStorage.removeItem('SidebarCurrentStatus');
    localStorage.removeItem('AnonymousListEnterprise');
    localStorage.removeItem('pdfjs.history');
  }

  /**
   * <pre>
   * <b>Method name: resetPassword</b>
   * <b>Explanation: </b> Method reset password
   * </pre>
   * @author GCS 2019/08/25 by linhdh
   *
   */
  resetPassword(url, data) {
    return this.apiService.post(url, data)
      .pipe(map(res => {
        return res;
      }));
  }

  // check hashkey reset password
  public checkHashKey(url) {
    return this.httpClient.get<any>(url).pipe();
  }

  /**
   * <pre>
   * <b>Method name: isLoggedIn</b>
   * <b>Explanation: </b> Method check login
   * </pre>
   * @author GCS 2019/08/25 by linhdh
   *
   */
  public isLoggedIn() {
    const lsToken = this.authService.getToken();
    if (lsToken) {
      return true;
    }
    return false;
  }


  /**
   * getPermissionInfo
   * Cache 1 request / phien: AuthGuard goi moi lan dieu huong nhung quyen
   * chi thay doi khi login lai, change-mode, logout -> cac diem do goi invalidatePermissionInfo().
   */
  private cachedPermissionInfo$: Observable<any>;
  private cachedPermissionInfoKey: string;

  public invalidatePermissionInfo() {
    this.cachedPermissionInfo$ = null;
    this.cachedPermissionInfoKey = null;
  }

  public getPermissionInfo() {
    const key = `${localStorage.getItem('userId')}|${localStorage.getItem('enterpriseId')}|${localStorage.getItem('userType')}`;
    if (!this.cachedPermissionInfo$ || this.cachedPermissionInfoKey !== key) {
      this.cachedPermissionInfoKey = key;
      this.cachedPermissionInfo$ = this.apiService.getSilently(Routes.GET_PERMISSION_INFO)
        .pipe(map(res => {
          return res;
        }),
        shareReplay(1),
        // shareReplay cache ca error: neu request dau fail thi clear de lan sau fetch lai
        catchError(err => {
          this.invalidatePermissionInfo();
          return throwError(err);
        }));
    }
    return this.cachedPermissionInfo$;
  }


  public AnonymousLogin(data: AnonymousLoginModel) {
    return this.apiService.post(Routes.ANONYMOUS_LOGIN, data)
      .pipe(map(res => {
        return res;
      }));
  }


  loginErp(url, username, password, isRemember, slideCaptcha, isNotHuman, erpToken) {
    return this.apiService.post(url, { username, password, slideCaptcha, isNotHuman, erpToken }).pipe(
      map(response => {
        if (response && response.data && response.data.token) {
          this.authService.storeAccessToken(response.data.token, isRemember);
          localStorage.setItem('tenantId', response.data.tenantId);
          localStorage.setItem('userId', response.data.userId);
          localStorage.setItem('userName', response.data.username);
          localStorage.setItem('fullName', response.data.fullName);
          localStorage.setItem('enterpriseId', response.data.enterpriseId);
          localStorage.setItem('parentId', response.data.parentId);
          localStorage.setItem('permissions', JSON.stringify(response.data.permissions));
          localStorage.setItem('featureStatus', JSON.stringify(response.data.featureStatus));
          localStorage.setItem('defaultPermission', JSON.stringify(response.data.defaultPermission));
          localStorage.setItem('userType', response.data.userType);
          localStorage.setItem('isParent', response.data.isParent);
          localStorage.setItem('jwtExp', response.data.jwtExp);
          // console.log('login data',response.data);
          this.currentUserSubject.next(response.data.token);
        }
        return response.data;
      })
    );
  }

  refreshToken() {
    return this.apiService.post(route.refreshToken).pipe(map(res => {
      return res;
    }));
  }

  refreshAnonymousToken() {
    return this.apiService.post(route.refreshAnonymousToken).pipe(map(res => {
      return res;
    }));
  }

  changeMode(data) {
    this.invalidatePermissionInfo();
    return this.apiService.post(route.changeMode, data)
      .pipe(map(res => {
        return res;
      }));
  }
  getListCloudCertificate() {
    return this.apiService.get(Routes.GET_LIST_CLOUD_CA)
      .pipe(map(res => {
        return res;
      }));
  }
  getCertsCloudCa(cloudCaUsername: string, providerName: string) {
    return this.apiService.get(Routes.GET_CLOUD_CA + `?cloudCaUsername=${cloudCaUsername}&providerName=${providerName}`)
      .pipe(map(res => {
        return res;
      }));
  }
  sendRequest(body:any) {
    return this.apiService.post(Routes.SEND_REQUEST, body)
    .pipe(map(res => {
      return res;
    }));
  }
  getResultSigning(transactionId: string) {
    return this.apiService.get(Routes.getResultSigning + `?transactionId=${transactionId}`)
      .pipe(map(res => {
        return res;
      }));
  }
  generateCaptcha(widthCaptcha?: any) {
    return this.apiService.get(`/captcha/generate${widthCaptcha ? `?widthCaptcha=${widthCaptcha}` : ''}`)
      .pipe(map(res => {
        return res;
      }));
  }
  verifyCaptcha(body:any) {
    return this.apiService.post('/captcha/verify', body)
    .pipe(map(res => {
      return res;
    }));
  }
  checkUserName(body:any){
    return this.apiService.post('/auth/forgot-password/check-user-name', body)
    .pipe(map(res => {
      return res
    }))
  }
  sendOtp(body:any){
    return this.apiService.post('/auth/forgot-password/send-otp', body)
    .pipe(map(res => {
      return res
    }))
  }
  resetPasswordOtp(body:any){
    return this.apiService.post('/users/reset-password-otp', body)
    .pipe(map(res => {
      return res
    }))
  }
}

interface AnonymousLoginModel {
  secretKey?: string;
  hashKey: string;
  email?: string;
  tenantId: string;
}
